/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef } from 'react';
import classnames from 'classnames';
import Slider from 'react-slick';
import ArticleWithTagsType from 'components/Article/ArticleWithTagsType';
import styles from './index.module.scss';
import SiderForwardButton from '../Utils/SiderForwardButton';
import { useWindowSize } from '../../utils/useWindowSize';

/* eslint-disable  @typescript-eslint/no-explicit-any */
interface IProps {
    className?: string;
    title?: string;
    list: Array<any>;
    projectId: string;
    isFromInnerPage?: boolean;
}

const ArticleSlider: React.FC<IProps> = ({
    className, title, list, projectId, isFromInnerPage
}): JSX.Element => {
    const testList = list.slice(0, 6);
    const sliderRef = useRef<Slider | null>(null);
    const size = useWindowSize();
    const settings = {
        className: `${styles.slick} article-slider`,
        arrows: true,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        pauseOnHover: true,
        swipe: false,
        dots: false,
        prevArrow: <></>,
        accessibility: true,
    };
    useEffect(() => {
        Array.from(document.getElementsByClassName('slick-active') as HTMLCollectionOf<HTMLDivElement>).forEach(element => {
            Array.from(element.getElementsByClassName(styles.articleContainer))[0].setAttribute('tabindex', '0');
        });
        Array.from(document.getElementsByClassName('slick-arrow slick-next') as HTMLCollectionOf<HTMLButtonElement>).forEach(element => {
            element.setAttribute('tabindex', '-1');
        });
    });

    return (
        <div className={classnames(className, styles.slider)}>
            <div
                className={classnames(styles.sliderContainer,
                    { [styles.isSlider]: size.width > 768 && testList.length > 4 })}
                style={{ padding: testList.length > 4 ? '0' : '0 12px' }}
            >
                {isFromInnerPage
                    ? <h3 className={styles.title} style={{ paddingLeft: testList.length > 4 ? '24px' : '12px' }}>{title}</h3>
                    : <div className={styles.title} style={{ paddingLeft: testList.length > 4 ? '24px' : '12px' }}>{title}</div>}
                {size.width > 768 && testList.length > 4 ? (
                    <>
                        <Slider ref={sliderRef} {...settings}>
                            {testList.map((article: IArticle) => (
                                <a
                                    href={`/${article.relatedMainCategory?.url}/${article.id}`}
                                    className={styles.articleContainer}
                                    key={`slick-ArticleWithTagsType-${article.id}${projectId}`}
                                    title={`移至文章-${article.title}`}
                                >
                                    <ArticleWithTagsType
                                        className={styles.article}
                                        type={1}
                                        image={article.imageURL}
                                        category={article.relatedMainCategory?.name}
                                        title={article.title}
                                        tags={article.relatedKeywords}
                                        scrollAnimation={false}
                                    />
                                </a>
                            ))}
                        </Slider>
                        <SiderForwardButton
                            className={styles.nextArrow}
                            handelClick={() => sliderRef.current?.slickNext()}
                        />
                    </>
                )
                    : (
                        <div className={styles.container}>
                            {testList.map((article: IArticle) => (
                                <a
                                    href={`/${article.relatedMainCategory?.url}/${article.id}`}
                                    className={styles.articleContainer}
                                    key={`ArticleWithTagsType-${article.id}${projectId}`}
                                    title={`移至文章-${article.title}`}
                                >
                                    <ArticleWithTagsType
                                        className={styles.article}
                                        type={1}
                                        image={article.imageURL}
                                        category={article.relatedMainCategory?.name}
                                        title={article.title}
                                        tags={article.relatedKeywords}
                                        scrollAnimation={false}
                                    />
                                </a>
                            ))}
                        </div>
                    )}
            </div>
        </div>
    );
};

ArticleSlider.defaultProps = {
    className: '',
    title: '',
    isFromInnerPage: false
};

export default ArticleSlider;
